<template>
  <validation-observer
    v-if="!isAdditional && showDriverPassPlus"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="driver-pass-plus"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row label="Have you passed your Pass Plus Test?">
        <validation-provider
          v-slot="{ failed }"
          :rules="{
            required: showDriverPassPlus,
          }"
          name="Driver Pass Plus"
          :vid="`${stepId}_driver-pass-plus`"
        >
          <radio
            v-model="questionData.driverPassPlus"
            :data-test="snakeCase(questionFields.driverPassPlus)"
            :name="`${stepId}.driver-pass-plus`"
            :items="constants.YES_NO"
            :error="failed"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import { UtcDate } from '@/helpers/date';
import QuestionBase from './Base';

export default {
  name: 'question-driver-pass-plus',
  extends: QuestionBase,
  data () {
    return {
      fields: ['driverPassPlus'],
    };
  },
  created () {
    this.$watch('showDriverPassPlus', val => {
      if (this.isAdditional || !this.questionData) return;
      this.questionData.driverPassPlus = val ? false : null;
    });
  },
  computed: {
    showDriverPassPlus () {
      if (!this.stepData.periodOfLicenceHeld) return false;
      const periodOfLicenceHeldDate = new UtcDate(this.stepData.periodOfLicenceHeld);
      if (!periodOfLicenceHeldDate.isValid()) return false;
      return new UtcDate().differenceInYears(periodOfLicenceHeldDate) === 0;
    },
  },
};
</script>
